import { PageType, PreparessrResultType } from '@nx-frontend/shared/types';

export function getPageType(path: string[]): PageType {
  const [firstPart, pageType, noteId] = path;
  let type: PageType = PreparessrResultType.NOT_FOUND;

  if (pageType === 'page' && noteId) {
    type = PreparessrResultType.NOTE;
  } else if (pageType === 'all') {
    type = PreparessrResultType.ALL;
  } else if (pageType === 'folder') {
    type = PreparessrResultType.FOLDER;
  } else if (pageType === 'tag') {
    type = PreparessrResultType.TAG;
  } else if (pageType === 'dashboard') {
    type = PreparessrResultType.DASHBOARD;
  } else if (pageType === 'files') {
    type = PreparessrResultType.FILES;
  } else if (pageType === 'settings') {
    // user settings /space/{workspaceId}/settings
    type = PreparessrResultType.SETTINGS;
  } else if (pageType === 'tasks') {
    type = PreparessrResultType.TASKS;
  } else if (pageType === 'notification') {
    type = PreparessrResultType.NOTIFICATION_PANEL;
  } else if (pageType === 'chat') {
    type = PreparessrResultType.CHAT;
  } else if (firstPart === 'dashboard') {
    type = PreparessrResultType.DASHBOARD;
  } else if (firstPart === 'settings') {
    // org settings /space/settings
    type = PreparessrResultType.ORG_SETTINGS;
  } else if (firstPart === 'automation' || pageType === 'automation') {
    // automation /space/automation
    type = PreparessrResultType.AUTOMATION;
  } else if (pageType === 'customizer') {
    type = PreparessrResultType.CUSTOMIZER;
  } else if (pageType === 'agents') {
    type = PreparessrResultType.AI_AGENTS;
  }

  return type;
}

export function getSettingsPageType(path: string[]): PageType {
  const [pageType] = path;
  let type: PageType = PreparessrResultType.NOT_FOUND;

  if (pageType === 'org' && path[1]) {
    type = PreparessrResultType.ORG_SETTINGS;
  }

  return type;
}
